export enum PrepListActionTypes {
  SEARCH_PREP_SUCCESS = "SEARCH_PREP_SUCCESS",
  SEARCH_PREP_ERROR = "SEARCH_PREP_ERROR",
  SET_CURRENT_PREP_SEARCH_TERM = "SET_CURRENT_PREP_SEARCH_TERM",
  LOAD_PREP_LIST = "LOAD_PREP_LIST",
  SET_CURRENT_PREP_PAGE = "SET_CURRENT_PREP_PAGE",
}
